import React, { useState, useEffect, useMemo } from 'react'
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import TableHeader from '../Utility/TableHeader';
import { ChartBarBigIcon } from 'lucide-react';
import LabelTopView from '../Utility/LabelTopView';
import HeaderWithButton from '../Utility/HeaderWithButton';
import { Pagination } from "../../helper/HelperTwo";
import DeleteConfirmation from '../Utility/DeleteConfirmation';

const ProjectManagerList = () => {

    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [projectManager, setProjectManager] = useState([])
    const [pagination, setPagination] = useState(null);
     const userId = JSON.parse(localStorage.getItem("user_id"));
    const fetchProjectManager = async () => {
        setLoading(true);
        const token = localStorage.getItem("token");
        try {
            const response = await axios.get('public/api/project-manager', {
                headers: { Authorization: `Bearer ${token}` },
            })

            setProjectManager(response?.data?.project_managers.data);
            setPagination(response?.data?.project_managers);
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm/");
            }
            setError("Network Failed. Please try again.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchProjectManager();
    }, [])


    const handlePageChange = (page) => {
        if (page !== '...') {
            fetchProjectManager(page,);
        }
    };

    if (loading) {
        <div className="h-screen bg-white">
            <div className="flex justify-center items-center h-full">
                <img
                    className="h-16 w-16"
                    src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
                    alt="loader"
                />
            </div>
        </div>
    }
    return (
        <div>

            <HeaderWithButton
                title="Project Manager "
                description="Project Manager "
                buttonText="Salesman"
                // onButtonClick={handleAddleadTypeOfWork}
                showButton={true}
            />
            <div className="grid grid-cols-1 gap-4 items-start sm:items-center">
                <div className="mt-6 overflow-x-auto rounded-lg shadow">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                                    S No
                                </th>
                                <th className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                                    Project Manager Name
                                </th>
                                <th className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                                    Project Manager Email
                                </th>
                                <th className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200 ">
                            {projectManager?.length > 0 ? (
                                projectManager?.map((projectManager, index) => (
                                    <tr key={index}>
                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                            {index + 1}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                                            {projectManager?.name}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                                            {projectManager?.user?.email}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                                            {(userId == 1 || userId == 2) && (
                                                <DeleteConfirmation
                                                    id_crypt={projectManager.id_crypt}
                                                    apiType={"project-manager"}
                                                    fetchClientData={fetchProjectManager}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="3"
                                        className="px-6 py-4 text-center text-sm text-gray-500"
                                    >
                                        No data available.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {pagination && (
                <Pagination
                    links={pagination.links}
                    currentPage={pagination.current_page}
                    totalResults={pagination.total}
                    from={pagination.from}
                    to={pagination.to}
                    lastPage={pagination.last_page}
                    onPageChange={handlePageChange}
                />
            )}
        </div>
    )
}

export default ProjectManagerList